export default __webpack_public_path__ + "Content/Images/content/piggy-bank-and-phone.png";